import publicRules from '@/js/formValidate'
export function validatorPortal(rule, value, callback){//alert(JSON.stringify(rule));
  if (!value) {
    return callback(new Error("邮箱不能为空"));
  } else {
    if (validateEmail(value)) {
      callback();
    } else {
      return callback(new Error('邮箱格式不正确'))
    }
  }
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/portalValidator.js